<template>
  <!--  {{this.items}}-->
  <el-form label-width="100px" class="app">
    <el-form-item label="薪资项目：">
      <el-input v-model="name" style="width: 90%" placeholder="防尘服" disabled/>
    </el-form-item>
    <el-form-item label="备注：">
      <el-input v-model="remark" style="width: 90%" :autosize="{ minRows: 3, maxRows: 6 }" type="textarea"/>
    </el-form-item>
    <h4 style="margin-left: 20px">发放规则：</h4>
    <el-form label-width="80px" class="bordered-container">
      <el-table :data="items"
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}">
        <el-table-column label="" width="50">
          <template v-slot="scope">
            <el-button class="custom-circle-button" type="danger" @click="removeItem(scope.$index)" plain circle>
              <svg width="20" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="2" y1="12" x2="22" y2="12" stroke="currentColor" stroke-width="2"></line>
              </svg>
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="序号" type="index" width="80"></el-table-column>
        <el-table-column label="部门">
          <template v-slot="scope">
            <el-select v-model="scope.row.department_id" filterable clearable @change="selectDepartment(scope.row.department_id)">
              <el-option v-for="item in departmentList" :key="item.value"
                         :label="item.name" :value="item.value"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="补贴金额(元/天)">
          <template v-slot="scope">
            <el-input v-model="scope.row.subsidy_amount" type="number" min="0"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <el-button class="mb-4" type="primary" plain icon="el-icon-plus"
                 @click="addItem" style="float: right;margin-top: 5px" circle></el-button>
    </el-form>
    <div style="margin-top: 7%;text-align: center ">
      <el-button type="primary" @click="saveButton">保存</el-button>
    </div>
  </el-form>
</template>
<script>
export default {
  name: "CleanClothingSubsidy",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      radiusGroup: [],
      remark: '',
      items: [],
      departmentList: [],
      selectedDepartments:{}
    }
  },

  methods: {
    addItem() {
      if (!this.items) {
        this.items = []
      }
      this.items.push({
        department_id: '',
        subsidy_amount: '',
      });
    },
    removeItem(index) {
      this.items.splice(index, 1);
    },
    // eslint-disable-next-line no-unused-vars
    selectDepartment(departmentValue) {
      console.log("departmentValue",departmentValue)
      this.selectedDepartments[departmentValue] = true;
    },
  async getDepartmentList() {
    this.$http("salaryRuleConfigureService.getDepartmentList").then(data => this.departmentList = data)
  },
  async saveButton() {
    for (let i = 1; i < this.items.length; i++) {
      if (Number(this.items[i].subsidy_amount) <= 0) {
        this.$message({
          message: "补贴金额必须为正数！",
          type: "error",
        });
        return;
      }
    }
    let pageId = {
      id: this.parentData.id
    }
    let params = {
      items: this.items,
      remark: this.remark,
      itemId: pageId.id
    }
    await this.$http("salaryRuleConfigureService.saveClothingSubsidy", params);
    this.$message.success("保存成功！");
    this.$fn.closeWindow();
    this.$fn.search();
  },
  async getData() {
    let params = {
      id: this.parentData.id
    }
    if (params.id !== undefined) {
      let data = await this.$http("salaryRuleConfigureService.getClothingSubsidyById", params);
      this.items = data.items
      this.remark = data.remark
    }
  }
}
,
created()
{
  this.getData();
  this.getDepartmentList();
}
}
</script>

<style scoped lang="less">

.demo-radius .title {
  color: var(--el-text-color-regular);
  font-size: 18px;
  margin: 10px 0;
}

.bordered-container {
  border: 0.5px solid lightgrey;
  padding: 10px 20px 45px 20px;
  width: 98%;
  margin: 10px;
}

.app {
  margin: 20px;
}
</style>